// extracted by mini-css-extract-plugin
export default {"dateSection":"HistoryDateSection_dateSection__-KjDW","dateTitle":"HistoryDateSection_dateTitle__wvbQ0","item":"HistoryDateSection_item__0EbT3"};